<template>
  <div class="text-center mt-5 py-5 bg-light">
    <h3 class="fw-bold mt-5 mb-5">{{ $t("cta.title") }}</h3>

    <p class="text-xl mb-5">
      {{ $t("cta.text.beforeStrong") }}
      <strong>{{ $t("cta.text.strong") }}</strong>
      {{ $t("cta.text.afterStrong") }}
    </p>

    <router-link class="btn btn-custom mb-5" to="/contact">
      {{ $t("cta.button.contact") }}
    </router-link>
  </div>
</template>

<script>
export default {
  name: "Cta",
};
</script>

<style></style>
